module.exports = __webpack_public_path__ + "img/shared.b2fc7baf.svg";